// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"399":"86eb5b99","748":"9634d854"}[chunkId] + ".chunk.css";
};